import { Alert, styled } from '@mui/material';
import DownloadIcon from '../../../../assets/file-download.svg';

export const DownloadButton = styled((props: any) => <img src={DownloadIcon} alt="Download" {...props} />)(() => ({
  width: '18px',
  height: '18px',
  marginLeft: '5px'
}));

export const WarningMessage = styled((props: any) => (
  <Alert severity="warning" {...props}>
    {props.children}
  </Alert>
))(() => ({
  marginTop: '10px',
  a: {
    color: 'rgb(102, 60, 0)',
    textDecoration: 'underline'
  }
}));

export const BoldText = styled('span')({
  fontWeight: 500
});

export const InsuranceErrorList = styled((props: any) => {
  return <ul {...props}></ul>;
})(() => ({
  listStyle: 'none',
  color: '#090909',
  marginTop: '20px',
  marginBottom: '20px',
  listStyleType: 'disc'
}));

export const InsuranceErrorListItem = styled((props: any) => {
  return <li {...props}></li>;
})(() => ({}));
